import { AbstractControl, FormControl, ValidationErrors, Validators, ValidatorFn } from '@angular/forms';
import { Constants } from '../util/Constants';

export interface ValidationResult {
    [key: string]: boolean;
}

export class PasswordValidator {

    passwordContainsFirstName = false;

    public static startC(control: FormControl): ValidationResult {
        let regex = /^[A-Za-z]/
        let beginChar = regex.test(control.value);

        const valid = beginChar;
        if (!valid) {
            return { startC: true };
        }
        return null;
    }

    public static strongU(control: FormControl): ValidationResult {
        let hasUpper = /[A-Z]/.test(control.value);
        const valid = hasUpper;
        if (!valid) {
            return { strongU: true };
        }
        return null;
    }

    public static strongL(control: FormControl): ValidationResult {
        let hasLower = /[a-z]/.test(control.value);
        const valid = hasLower;
        if (!valid) {
            return { strongL: true };
        }
        return null;
    }

    public static strongD(control: FormControl): ValidationResult {
        let hasNumber = /\d/.test(control.value);
        const valid = hasNumber;
        if (!valid) {
            return { strongD: true };
        }
        return null;
    }
    public static strongS(control: FormControl): ValidationResult {
        //let hasSpecial = /\W/.test(control.value);
        //let hasSpecial = /[!@#%]/.test(control.value);
        let hasSpecial = /[!"#$%&'()*+,-./:;<=>?@[\\\]^_`{ |}~]/.test(control.value);
        
        const valid = hasSpecial;
        if (!valid) {
            return { strongS: true };
        }
        return null;
    }

    public static strongDS(control: FormControl): ValidationResult {
        //let hasDSspecial = /[^a-zA-Z0-9!@#%]/.test(control.value);
        let hasDSspecial = /^[a-zA-Z0-9!"#$%&'()*+,-./:;<=>?@[\\\]^_`{ |}~]*$/.test(control.value);
        
        //const hasSpace = /\s/.test(control.value);
        const valid = hasDSspecial  // || hasSpace;
        if (!valid) {
            return { strongDS: true };
        }
        return null;
    }

    public static strongR(control: FormControl): ValidationResult {
        let hasRepeatedChars = /(.)\1{2}/.test(control.value);
        const valid = hasRepeatedChars;
        if (valid) {
            return { strongR: true };
        }
        return null;
    }

    public static matchValidator(source: string, target: string): ValidatorFn {

        return (control: AbstractControl): ValidationErrors | null => {
            const sourceCtrl = control.get(source);
            const targetCtrl = control.get(target);

            return sourceCtrl && targetCtrl && sourceCtrl.value !== targetCtrl.value
                ? { mismatch: true }
                : null;
        };
    }

    public static mismatchValidator(source: string, target: string): ValidatorFn {

        return (control: AbstractControl): ValidationErrors | null => {
            const sourceCtrl = control.get(source);
            const targetCtrl = control.get(target);

            return sourceCtrl && targetCtrl && sourceCtrl.value === targetCtrl.value
                ? { match: true }
                : null;
        };
    }

    public static passwordContainsFName(source: string, target: string): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            const sourceCtrl = control.get(source);
            const targetCtrl = control.get(target);

            if (sourceCtrl.value && targetCtrl.value) {
                const normalizedSource = (sourceCtrl.value).normalize('NFKC');
                const normalizedTarget = (targetCtrl.value).normalize('NFKC');
                return (sourceCtrl.value == targetCtrl.value || (normalizedTarget.toLowerCase().includes(normalizedSource.toLowerCase())))
                    ? { passwordContainsFName: true } : null;
            }
            return null;
        }
    };

    public static passwordUserContainsFName(source: string, target: string): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            const sourceCtrl = source;
            const targetCtrl = control.get(target);


            if (sourceCtrl && targetCtrl.value) {
                return (sourceCtrl.toLowerCase() === targetCtrl.value.toLowerCase() || targetCtrl.value.toLowerCase().includes(sourceCtrl.toLowerCase()))
                    ? { passwordContainsFName: true } : null;
            }
            return null;
        }
    };

    public static passwordUserContainsLName(source: string, target: string): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            const sourceCtrl = source;
            const targetCtrl = control.get(target);


            if (sourceCtrl && targetCtrl.value) {
                return (sourceCtrl.toLowerCase() === targetCtrl.value.toLowerCase() || targetCtrl.value.toLowerCase().includes(sourceCtrl.toLowerCase()))
                    ? { passwordContainsLName: true } : null;
            }
            return null;
        }
    };

    public static passwordUserContainsEmail(source: string, target: string): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            const sourceCtrl = source;
            const targetCtrl = control.get(target);

            if (sourceCtrl && targetCtrl && targetCtrl.value) {
                const sourceValue = source.toLowerCase();
                const targetValue = targetCtrl.value.toLowerCase();
                if (sourceValue === targetValue || targetValue.includes(sourceValue))
                    return { passwordContainsEmail: true };
                else
                    return null;
            }
            return null;
        }
    };
    public static newpasswordUserContainsEmail(source: string, target: string): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            const sourceCtrl = control.get(source);
            const targetCtrl = control.get(target);

            if (sourceCtrl && sourceCtrl.value && targetCtrl && targetCtrl.value) {
                const sourceValue = sourceCtrl.value.toLowerCase();
                const targetValue = targetCtrl.value.toLowerCase();
                if (sourceValue === targetValue || sourceValue.includes(targetValue))
                    return { passwordContainsEmail: true };
                else
                    return null;
            }
            return null;
        }
    };

    public static passwordContainsFNameValue(source: string, target: string): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {

            if (source && target) {
                return (source == target || target.includes(source))
                    ? { passwordContainsFName: true } : null;
            }
            return null;
        }
    };



    public static passwordContainsLName(source: string, target: string): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            const sourceCtrl = control.get(source);
            const targetCtrl = control.get(target);

            if (sourceCtrl.value && targetCtrl.value) {
                const normalizedSource = (sourceCtrl.value).normalize('NFKC');
                const normalizedTarget = (targetCtrl.value).normalize('NFKC');
                return (sourceCtrl.value == targetCtrl.value || (normalizedTarget.toLowerCase().includes(normalizedSource.toLowerCase())))
                    ? { passwordContainsLName: true } : null;
            }
            return null;
        }
    }

    public static passwordLengthValidator(minLength: number): ValidatorFn {
        return (control: AbstractControl): { [key: string]: any } | null => {
          const value = control.value;
          if (value) {        
            const passwordWithoutSpaces = value.replace(/\s/g, '');
            const passwordLength = passwordWithoutSpaces.length;
      
            if (passwordLength < minLength) {
                return { passwordTooShort: { requiredLength: minLength, actualLength: passwordLength } };
            }
          }      
            return null;
        };
    }

    public static invalidEmail(control: FormControl): ValidationResult {    
        const email = control.value;
        if (!email) {
          return null; // No validation required if email field is empty
        }
    
        //const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9._-]+\.[a-zA-Z_-]{2,}$/;
        //const emailRegex = /^[A-Za-zÀ-ÿ0-9]+([!#$%&'*+/=?^_`{|}~.-]?[A-Za-zÀ-ÿ0-9]+)*@[a-zA-Z0-9À-ÿ._-]+\.[a-zA-ZÀ-ÿ_-]{1,}$/;
        // Underscore not allowed in Email domain
        
        //const emailRegex = /^[a-zA-ZÀ-ÿ0-9._%+!#$%&'*+/=?^_`{|}~][a-zA-ZÀ-ÿ0-9._%+!#$%&'*+/=?^_`{|}~-]*[a-zA-ZÀ-ÿ0-9._%+!#$%&'*+/=?^_`{|}~]@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        //const emailRegex = /^[A-Za-zÀ-ÿ0-9_-]+([!#$%&'*+/=?^_`{|}~.-]?[A-Za-zÀ-ÿ0-9]+)*@[a-zA-Z0-9À-ÿ.-]+\.[a-zA-ZÀ-ÿ-]{2,}$/;

        const emailRegex = Constants.EF_EMAIL;
        const emailParts = email.split('@');

        if ((emailParts.length !== 2) || (emailParts[0].startsWith('.') || emailParts[0].endsWith('.')) || email.indexOf('..') !== -1) {
          return { invalidEmail: true };
        }

        if (!emailRegex.test(email)) {
            return { invalidEmail: true };
        }
    
        return null; // Validation successful
      };    

      public static invalidInputAsterisk(control: FormControl): ValidationResult {    
        
        const inputValue = control.value;
        const asteriskRegex = Constants.SEARCH_ASTERISK;

        if (!inputValue) {
          return null;
        }

        if (inputValue && inputValue.trim() === '*' || inputValue.indexOf('**') !== -1)
        {
            return {invalidInputAsterisk: true}
        }

        if (!asteriskRegex.test(inputValue) && inputValue.indexOf('*') !== -1) {
            return { invalidInputAsterisk: true };
        }
    
        return null;
      };   
}


